// Define an enumeration for route identifiers
export enum RoutesId {
  root = 'root', // root route

  notFound = 'notFound',

  home = 'home',
  // auth
  login = 'login',
  loginByToken = 'loginByToken',
  setPassword = 'setPassword',
  updateExpiredPassword = 'updateExpiredPassword',
  twoFactorConnection = 'twoFactorConnection',
  // admins
  admins = 'admins',
  admin = 'admin',
  // clients
  clients = 'clients',

  personClients = 'personClients',
  personClient = 'personClient',
  createPersonClient = 'createPersonClient',
  personClientVersion = 'personClientVersion',

  representativeClient = 'representativeClient',
  representativeClientVersion = 'representativeClientVersion',

  legalClients = 'legalClients',
  legalClient = 'legalClient',
  createLegalClient = 'createLegalClient',
  legalClientVersion = 'legalClientVersion',
  legalClientRepresentativeVersion = 'legalClientRepresentativeVersion',
  legalClientHeadVersion = 'legalClientHeadVersion',
  legalClientLegalHeadVersion = 'legalClientLegalHeadVersion',
  legalClientFirstHeadVersion = 'legalClientFirstHeadVersion',

  legalRepresentative = 'legalRepresentative',
  legalClientHead = 'legalClientHead',
  legalClientLegalHead = 'legalClientLegalHead',
  legalClientFirstHead = 'legalClientFirstHead',
  legalClientBeneficiary = 'legalClientBeneficiary',
  legalClientBeneficiaryVersion = 'legalClientBeneficiaryVersion',
  legalClientBranch = 'legalClientBranch',
  legalClientBranchVersion = 'legalClientBranchVersion',

  // order
  orders = 'orders',
  order = 'order',
  createOrder = 'createOrder',

  // directories
  directories = 'directories',
  directory = 'directory',
  directoryRecord = 'directoryRecord',
  createDirectoryRecord = 'createDirectoryRecord',
  productionCalendar = 'productionCalendar',

  // Form FM1
  formFM1 = 'formFM1',

  // administration
  administration = 'administration',
  accountingSystem = 'accountingSystem',
  onboardingSettings = 'onboardingSettings',

  // settings
  settings = 'settings',
  timezoneSettings = 'timezoneSettings',
  passwordSettings = 'passwordSettings',
  notificationsSettings = 'notificationsSettings',

  // operation
  operations = 'operations',
  operation = 'operation',
  createOperation = 'createOperation',
}
